import * as React from "react";

import * as moment from "moment";
import { ReactElement } from "react";

interface ClockState {
    date: moment.Moment;
}

export class Clock extends React.Component<Record<string, never>, ClockState> {

    timerId: number;

    constructor(props: Record<string, never>) {
        super(props);
        this.state = { date: moment() };
    }

    componentDidMount(): void {
        this.timerId = window.setInterval(
            () => this.tick(),
            1000
        );
    }

    componentWillUnmount(): void {
        clearInterval(this.timerId);
    }

    tick(): void {
        this.setState({
            date: moment()
        });
    }

    render(): ReactElement {
        return (
            <div className="clock">
                <h1>{this.state.date.format("LT")}</h1>
                <h3>{this.state.date.format("dddd D MMMM")}</h3>
            </div>
        );
    }
}
